export default "__VITE_ASSET__xRvR6s4j__"